import React, { Fragment } from "react";
import * as R from 'ramda'

export const thisMock = window.location.origin == "http://localhost:3000" || window.location.origin == "http://localhost:3000" ? true : false;
//export const thisMock = true;
export const thisPost = true    

export const BaseAddress = ((window.location.hostname != 'localhost') && (R.startsWith('/react-template-u', window.location.pathname))) 
? window.location.origin + window.location.pathname.substring(0, window.location.pathname.indexOf("/", 2)) 
: window.location.origin


export let apiDataUIUrl = `` //${window.location.origin}/global-ui-service/api/values/GetUniversalUi/`

if (!R.contains("localhost", window.location.host))
  apiDataUIUrl = `${window.location.origin}/global-ui-service/api/values/GetUniversalUi/`

export const apiDataUrl = `${BaseAddress}/api/values/GetMainData/`
export const apiSaveUrl = `${BaseAddress}/api/values/SaveData/`
export const apiListUrl = `${BaseAddress}/api/values/GetPickList/`


export const MESS_TO_SAVE = 'Сохранение успешно !'

export const SHOW_TOOL_BAR = true
export const SHOW_LEFT_SIDE_BAR = false
export const SHOW_FOOTHER = false


